import { useContext, useEffect } from "react";
import { AuthContext } from "../../context/auth.context";
import type { JwtPayload } from "../../types/auth";
import { useNotification } from "../Notification/NotificationProvider";
import { bindApiErrToast, installApiErrInterceptor } from "../../utils/apiErrorInterceptor";

export const ApiErrorToastBridge = () => {
  const { showNotification } = useNotification();
  const { user } = useContext(AuthContext);

  useEffect(() => {
    bindApiErrToast(showNotification, () => {
      const u = user as JwtPayload | null | undefined;
      if (!u) return null;
      return { uid: u.uid, sub: u.sub };
    });
    installApiErrInterceptor();
  }, [showNotification, user]);

  return null;
};
